import { attachTooltipController } from "./tooltipRegistry";

const REQUIRED_CSS_SUPPORT = [
  "anchor-name: --a",
  "position-anchor: --a",
  "position-area: bottom span-right",
  "position-try-fallbacks: flip-block",
  "position-try-fallbacks: flip-inline",
  "position-visibility: anchors-visible",
] as const;

const supportsPopover = (ownerWindow: Window & typeof globalThis): boolean => {
  const elementPrototype = ownerWindow.HTMLElement.prototype;
  return typeof elementPrototype.showPopover === "function" && typeof elementPrototype.hidePopover === "function";
};

const supportsAnchorPositioning = (ownerWindow: Window & typeof globalThis): boolean =>
  Boolean(ownerWindow.CSS) && REQUIRED_CSS_SUPPORT.every(query => ownerWindow.CSS.supports(query));

export const isDSTooltipSupported = (ownerDocument: Document = document): boolean => {
  const ownerWindow = ownerDocument.defaultView;
  if (!ownerWindow) return false;
  return supportsPopover(ownerWindow) && supportsAnchorPositioning(ownerWindow);
};

export const initDSTooltip = (ownerDocument: Document = document): (() => void) | undefined =>
  isDSTooltipSupported(ownerDocument) ? attachTooltipController(ownerDocument) : undefined;
